import React from 'react';
import classNames from 'classnames';

import NewToggleCTALinkButton from 'components/essentials/NewToggleCTALinkButton';

const TextContentButtonGroup = ({ mainButton, subButton, className }) => (
  <div className={classNames('flex !flex-col gap-4 w-fit', className)}>
    {mainButton && <NewToggleCTALinkButton {...mainButton} />}
    {subButton && <NewToggleCTALinkButton {...subButton} />}
  </div>
);

export default TextContentButtonGroup;
